import React, { Fragment, useEffect, useState } from "react"
import { useDebouncedCallback } from "use-debounce"
import { useAtom as GetAtom } from "jotai"
import classNames from "classnames"
import { Search, X } from "lucide-react"
import NavSaleSubMenu from "./NavSaleSubMenu"
import { checkoutIsStep0, checkoutIsStep1 } from "../../store/checkout"
import CheckoutBackButton from "../Checkout/CheckoutBackButton"
import Input from "../Elements/Form/Input"
import { useItemSearchText } from "../../hooks/item"

const WAIT_INTERVAL = 700

interface Props {
  onSearchChange: (value: string) => void
}

function NavSaleSearch({ onSearchChange }: Props) {
  const searchText = useItemSearchText()

  const [isStep0] = GetAtom(checkoutIsStep0)
  const [isStep1] = GetAtom(checkoutIsStep1)

  const [searchValue, setSearchValue] = useState(searchText || "")

  useEffect(() => {
    if (searchText !== searchValue) {
      setSearchValue(searchText)
    }
  }, [searchText])

  const [, setSearchTextInput] = useState("")
  const debounced = useDebouncedCallback(async (text) => {
    await onChangeSearchText(text)
  }, WAIT_INTERVAL)

  const onChangeSearch = async (searchText?: string) => {
    setSearchValue(searchText)

    // Search after delay
    await debounced(searchText)
  }

  const onChangeSearchText = async (searchText?: string) => {
    setSearchTextInput(searchText)
    onSearchChange(searchText)
  }

  const handleSearchClear = async () => {
    setSearchValue("")
    await onChangeSearchText("")
  }

  return (
    <Fragment>
      <div className="grid items-center gap-8 lg:grid-cols-3">
        <div className="col-span-0 lg:col-span-2">
          {/* Search */}

          <div>
            <div
              className={classNames({
                hidden: !isStep0,
              })}
            >
              <div className="mt-1 flex rounded-md shadow-sm">
                <div className="relative flex flex-grow items-stretch text-white focus-within:z-10 focus-within:text-gray-600">
                  <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                    <Search
                      className="size-5 text-white/70"
                      aria-hidden="true"
                    />
                  </div>

                  <Input
                    className="block h-12 w-full rounded-none rounded-l-md border border-transparent bg-white/20 py-2 pr-3 pl-10 leading-5 text-white placeholder-white/70 focus:border-transparent focus:bg-white focus:text-gray-900 focus:placeholder-gray-500 focus:ring-0 focus:outline-none sm:text-sm"
                    type="search"
                    name="search"
                    value={searchValue}
                    placeholder="Поиск товара или сканирование штрихкода..."
                    onChange={(e) => onChangeSearch(e.target.value)}
                  />
                </div>

                <button
                  type="button"
                  className="relative -ml-px inline-flex items-center space-x-2 rounded-r-md border border-transparent bg-white/30 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-white/90 hover:text-gray-900 focus:border-transparent focus:bg-white/90 focus:text-gray-900 focus:ring-0 focus:outline-none"
                  onClick={() => handleSearchClear()}
                >
                  <X className="size-5" aria-hidden="true" />
                </button>
              </div>
            </div>

            <div
              className={classNames({
                hidden: !isStep1,
              })}
            >
              <CheckoutBackButton />
            </div>
          </div>
        </div>

        <div>
          <NavSaleSubMenu />
        </div>
      </div>
    </Fragment>
  )
}

export default NavSaleSearch
